import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//components
import {VendorLineItemEditComponent} from '../../components/Editors/VendorLineItemEdit.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseGridComponent }         from '../../baseclasses/BaseGrid.component';

@Component({
  selector: 'my-fullservicepricinglineitem-grid',
  templateUrl: './FullServicePricingLineItemGrid.component.html',
  providers: [{provide: BaseGridComponent, useExisting: forwardRef(() => FullServicePricingLineItemGridComponent)}]
})
export class FullServicePricingLineItemGridComponent extends BaseGridComponent {
    lineItems: ent.VendorLineItem[] = [];
    selectedLineItems: ent.VendorLineItem[] = [];
    editedLineItem: ent.VendorLineItem;

    cols: any[];

    
    @Output() public lineItemsChanged: EventEmitter<number> = new EventEmitter();
    
    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, private router: Router) 
    {
        super();
    }

        
   

    ngOnInit(): void {
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'VendSize.Name', header: 'Vend Size' }
            // { field: 'brand', header: 'Brand' },
            // { field: 'color', header: 'Color' }
        ];

        this.editedLineItem = new ent.VendorLineItem();
    }

    
}